export default "__VITE_ASSET__63795e42__"